import { jsx } from 'react/jsx-runtime';
import { EditorStack } from './EditorStack.js';

const EditorFieldGroup = ({ children }) => {
  return /* @__PURE__ */ jsx(EditorStack, { gap: 1, children });
};

export { EditorFieldGroup };
//# sourceMappingURL=EditorFieldGroup.js.map
